<!-- organisation-ontology-values-dialog.component.html -->
<h2 mat-dialog-title>Werte für {{ data.organisationName }}</h2>

<mat-dialog-content>
    <pre>{{ parsed | json }}</pre>
</mat-dialog-content>

<mat-dialog-actions style="align-items: end;">
    <button mat-button (click)="close()">Schließen</button>
</mat-dialog-actions>